import { useQuery } from '@tanstack/react-query';

import { UnwrapArray } from '@sbv-clients/util-misc';

import { useApi } from '..';
import { ReportCacheKeys } from './util/cache-keys';

export const useAbsenceReportGet = (
  departmentId: number,
  employeeId: number,
  startDate: string,
  endDate: string
) => {
  const api = useApi();
  return useQuery({
    queryKey: [
      ReportCacheKeys.AbsenseReport,
      { departmentId, employeeId, startDate, endDate },
    ],
    queryFn: async () => {
      const safeId: any = departmentId || null;
      return api.reportsApi
        .reportsAbsenceReportGet({
          departmentId: safeId,
          employeeId: employeeId || undefined,
          startDate,
          endDate,
        })
        .then((response) => response?.data?.data ?? {});
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(startDate) && Boolean(endDate),
  });
};

type AbsenceReportGetResponseType = NonNullable<
  ReturnType<typeof useAbsenceReportGet>['data']
>;

export type AbsenceReportType = NonNullable<
  UnwrapArray<AbsenceReportGetResponseType['absences']>
>;
